/** Home-page smooth scroll through Lenis (loaded on the index template only, see theme.liquid): synced with GSAP ScrollTrigger when present, respecting `prefers-reduced-motion`, disabled in the theme editor and paused while a drawer is open (full-screen modals use `data-lenis-prevent` instead); the instance is exposed on `window.lenis`. */
(function () {
  var reduceMotion =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduceMotion) return;
  if (window.Shopify && window.Shopify.designMode) return;
  // No smooth scroll on touch devices: native scroll is expected there, Lenis does not smooth touch anyway, and bailing out early avoids a useless CDN request.
  if (window.matchMedia && window.matchMedia("(pointer: coarse)").matches) return;

  var LENIS_SRC = "https://cdn.jsdelivr.net/npm/lenis@1.1.13/dist/lenis.min.js";

  var script = document.createElement("script");
  script.src = LENIS_SRC;
  script.async = true;
  script.addEventListener("load", init);
  document.head.appendChild(script);

  function init() {
    if (typeof Lenis === "undefined") return;

    var lenis = new Lenis({
      // `lerp` bas = rattrapage plus progressif → défilement plus fluide.
      lerp: 0.09,
      smoothWheel: true,
      wheelMultiplier: 0.9,
    });
    window.lenis = lenis;

    // Sync GSAP ScrollTrigger si présent (il est chargé à la demande ailleurs,
    // donc on teste à chaque scroll plutôt qu'une seule fois à l'init).
    lenis.on("scroll", function () {
      if (window.ScrollTrigger) window.ScrollTrigger.update();
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    // Le body est déjà verrouillé quand un drawer s'ouvre : on stoppe Lenis
    // pour que le défilement natif du drawer fonctionne, puis on relance.
    document.addEventListener("drawer:open", function () {
      lenis.stop();
    });
    document.addEventListener("drawer:close", function () {
      lenis.start();
    });
  }
})();
